export default {
  storefront_not_found: {
    title: 'Nie znaleziono witryny',
    description: 'Utwórz witrynę.',
  },
};
